import {useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { doGetMarketMovers } from '../store/actions/marketMovers';
import { selectMarketMovers, selectChannelCellExists, selectMobileMenuOpen } from '../store/selectors';
import { ClusterContentApi } from '@cluster/web-components';
import { RootState } from '../store/reducers/persistedReducer';
import { doPanToCell } from '../store/actions/channelLayout';
import { ReactComponent as GoToIcon } from '../images/goto.svg'
import { doSetMobileMenuOpen } from '../store/actions/system';
import moment from 'moment'
import firebase from '../lib/firebase';

import styles from './NewsAlerts.module.scss'

let apiTimer: number;

export default function MarketMovers() {
  const marketMovers = useSelector(selectMarketMovers);
  const marketMoversLoading = useSelector((state: RootState) => state.marketMovers.fetchStatus.loading);
  const marketMoversError = useSelector((state: RootState) => state.marketMovers.fetchStatus.userMessage);
  const mobileMenuOpen = useSelector(selectMobileMenuOpen);

  const dispatch = useDispatch();

  const panToCell = (cellId: number) => {
    dispatch(doPanToCell(cellId));

    if (mobileMenuOpen) {
      dispatch(doSetMobileMenuOpen(false));
    }

    // Firebase event
    firebase.analytics.logEvent("focus_event", {type: "news", cell_id: cellId});
  }

  // Get market movers and start a timer to refresh them.
  useEffect(() => {
    const refreshData = () => {
      dispatch(doGetMarketMovers());

      apiTimer = window.setTimeout(() => {
        refreshData();
      }, 1000*60*10) // 10 minutes
    }

    refreshData();

    return function cleanup() {
      window.clearTimeout(apiTimer);
    }
  }, [dispatch])

  const items = marketMovers.map((item) => {
    const momentDate = moment(item.date);
    return <MarketMover key={item.id}
            title={item.title}
            date={momentDate.isAfter() ? false : momentDate.fromNow()}
            author={item.author}
            direction={item.direction}
            topic={item.topic??""}
            topic_img_src={item.topic_img_src}
            cellId={item.cellId}
            panToCell={panToCell}
          />
  });

  let message: string | undefined;

  if (marketMoversLoading) {
    message = "Loading...";
  } else if (marketMoversError) {
    message = marketMoversError;
  } else if (items.length === 0) {
    message = "No news available.";
  }

  return (
    <div className={styles.list}>
      {typeof message === "undefined" ? items : <div className={styles.message}>{ message }</div>}
    </div>
  );
}

type MarketMoverProps = {
  title: string,
  date: string | false,
  author: string,
  direction: ClusterContentApi.FieldDirection,
  topic: string,
  topic_img_src: string | undefined,
  cellId: number | null,
  panToCell: Function
}


function MarketMover(props: MarketMoverProps) {
  const cellExists = useSelector((state: RootState) => selectChannelCellExists(state, props.cellId));

  const highlightCell = () => {
    if (cellExists) {
      props.panToCell(props.cellId);
    }
  }

  let host = process.env.REACT_APP_CLUSTER_WEB_HOST ?? "";

  let button: JSX.Element | undefined;

  if (cellExists) {
    button = <button className={styles.button}><GoToIcon /></button>
  }

  return (
    <div className={cellExists ? styles.clickableItem : styles.item} onClick={highlightCell}>
      <div className={styles.imageWrapper}>
        <img src={host + props.topic_img_src} alt={props.topic} className={styles.topicImage} />
        <img src={host + "/themes/custom/cluster/images/direction-" + props.direction + ".svg"} className={styles.directionImage} alt={props.direction}/>
      </div>
      <div className={styles.itemDesc}>
        {props.title}
      </div>
      {/* { props.date ? <div className={styles.dateAuthor}>{props.date}</div> : "" } */}
      {button}
    </div>
  );
}